import { Button, Typography } from "@mui/material";
import { FoodsIcon } from "@foodpilot/foods";
import { BreadcrumbType } from "src/components/Breadcrumb/Breadcrumbs";

type BreadcrumbProps = {
    breadcrumb: BreadcrumbType;
};
export const Breadcrumb = (props: BreadcrumbProps) => {
    const { breadcrumb } = props;
    return (
        <li>
            <Button
                className="breadcrumb"
                onClick={breadcrumb.action}
                disabled={breadcrumb.disabled}
                sx={{ maxWidth: "100%", minWidth: 0 }}
            >
                <Typography
                    variant="body"
                    title={breadcrumb.label}
                    sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
                >
                    {breadcrumb.label}
                </Typography>
            </Button>
            <FoodsIcon icon="arrowRightShort" size={2} />
        </li>
    );
};
